'use client'

import { useEffect } from 'react'

// Deja la marca de que React montó de verdad.
//
// Es la única señal que mira el aviso de navegador incompatible (ver
// lib/compat/aviso.js): si este efecto nunca corre, el bundle no arrancó y los
// botones de la página están muertos aunque se vean perfectos.
//
// Va en el layout para que quede en TODAS las páginas, y no cuelga de ninguna
// otra lógica a propósito: cualquier condición extra acá sería un falso positivo
// del cartel en las páginas donde esa condición no se cumple.
export default function MarcaHidratado() {
  useEffect(() => {
    if (typeof window === 'undefined') return
    window.__bcmHidratado = true
    // Si el cartel llegó a aparecer (hidratación muy lenta), lo sacamos.
    if (typeof window.__bcmOcultarAviso === 'function') window.__bcmOcultarAviso()
  }, [])

  return null
}
